import React, { useCallback, useEffect, useState } from 'react';
import FormRenderer from '../../form-renderer'
import { Box } from '@mui/material';
import reSignupRecord, { ReSignUpRecord } from './re-signup-record';
import { cloneDeep } from 'lodash';
import validateFormFields, { IFieldValidationErrors, ValidationErrorFields } from '../../../utils/validate-form-fields';
import SubmitSpreadsheetHandler from '../../../utils/api-handlers/submit-spreadsheet-handler';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import RecaptchaVerify from '../../../utils/recaptcha-verify';
import ErrorMessages from '../../../utils/errors';
import reSignupFieldConfig, { RESIGNUP_FORM_KEY } from './re-signup-field-config';
import ReSignupFields from './re-signup-fields';
import { EmailTagType } from '../../mailing/build-mail-tag';

interface iFormError {
    error?: string,
}
interface Props {
    submitForm: boolean;
    cleanSubmitFlag: () => void;
    iAmBusy: (state: boolean) => void;
    handleFinishFlow: (result: string[] | []) => void;
    progressCallBack: (progress: number) => void;
}

const ReSignUpForm: React.FC<Props> = ({submitForm, cleanSubmitFlag, iAmBusy, handleFinishFlow, progressCallBack}) => {
    const [record, setRecord] = useState<ReSignUpRecord>(cloneDeep(reSignupRecord))
    const [fieldErrors, setFieldErrors] = useState<IFieldValidationErrors[]>([])
    const [token, setToken] = useState<string | undefined>(undefined);
    const [errors, setErrors] = useState<string[]>([]);
    const [formErrors, setFormErrors] = useState({} as iFormError);
    const formFields = reSignupFieldConfig.map((config: any) => ReSignupFields.filter(field => field.key === config.key)[0]);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleChange = (field: Record<string, any>, value: string) => {
        let currentRecord = cloneDeep(record);
        let newRecord;

        // handles changes
        if (value === 'unset') {
            const formValues = currentRecord.formValues;
            const toBUnsetKey = field.key;
            const { [toBUnsetKey]: removedProp, ...updatedFormValues } = formValues as Record<any, string>;
            newRecord = {
                ...record,
                formValues: {
                    ...updatedFormValues,
                }
            };
        } else {
            newRecord = {
                ...record,
                formValues:{
                    ...record.formValues,
                    [field.key]: value,
                }
            };
        }
        // validates and updates error on "onChange" field only
        setFieldErrors(validateFormFields([field], newRecord));
        setRecord(newRecord);
    }

    const handleReCaptchaVerify = useCallback(async () => {
        if (!token) {
            const { errorObject, result, resultToken } = await RecaptchaVerify(executeRecaptcha);
            if (errorObject) { setFormErrors(errorObject) };
            if (token) { setToken(resultToken) };
            return result
        }
        return false

    }, [executeRecaptcha, token]);

    useEffect(()=>{
        const handleReCaptcha = async () => {
            await handleReCaptchaVerify();
        }
        if(submitForm) {
            setFieldErrors(validateFormFields(formFields, record));
            console.log("||FORM READY TO SUBMIT")
            // check for errors before mutation
            console.log('Record up to here ==>', record);
            const formErrors = ValidationErrorFields(validateFormFields(formFields, record));
            setErrors(formErrors);
            if (!!formErrors.length) {
                console.log('Cannot update cloud worksheet. Check form')
            } else {
                const successToken = handleReCaptcha();
                console.log('Record re-signup', record);
                if (successToken) {
                    console.log('Token is: ', successToken)
                    iAmBusy(true);
                    SubmitSpreadsheetHandler({
                        record,
                        formConfig: reSignupFieldConfig,
                        formKeys: RESIGNUP_FORM_KEY,
                        spreadsheetId: '1M111j6UayfIIuZDeJQmt6cia4L-kzkOg9-FSYJWZFxQ',
                        range: `'REINSCRIPTOS'!A2:E2`,
                        idRange: `'REINSCRIPTOS'!A:A`,
                        progressCallBack,
                        tutorEmailTagType: EmailTagType.TutorReSignup,
                        internalEmailTagType: EmailTagType.InternalReSignup,
                        validateRange: "'ACTIVOS'!C:D",
                        validateRangeId: record.formValues[RESIGNUP_FORM_KEY.documentoId]
                    })
                    .then((response) => {
                        iAmBusy(false)
                        setRecord(cloneDeep(reSignupRecord)); // Cleans the signup record so they can use the form again.
                        //cleans record on success
                        setRecord({
                            formId: 're-signup-form',
                            formValues: {
                            }
                        })
                        cleanSubmitFlag();
                        handleFinishFlow(["OK"]);
                        iAmBusy(false);
                    })
                    .catch((error) => {
                        iAmBusy(false)
                        //The record will net be cleaned, as if the try again in the same session, they can continue with the form already filled.
                        handleFinishFlow(error);
                    })
                } else {
                    console.error('Errors in the form:', formErrors)
                    setFormErrors({ error: ErrorMessages.errorEnFormulario })
                }
            }
        }
        cleanSubmitFlag();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitForm])

    return (
        <Box>
            <FormRenderer
                fields={formFields} 
                record={record} 
                onChange={handleChange} 
                handleClose={() => null}
                errors={fieldErrors}             
            />
        </Box>
    )
}

export default ReSignUpForm;
